module.exports = __webpack_public_path__ + "static/media/brushsan-3.62cabaf3.png";